import { ProjectPage } from 'src/projects/ProjectPage.tsx';
import { ReactElement } from 'react';
import { RouteObject } from 'react-router/dist/lib/context';

export const createChildrenRoute = (Index: ReactElement): RouteObject[] => [
    {
        index: true,
        element: Index,
    },
    {
        path: 'projects/:page',
        element: <ProjectPage/>,
    },
];
